<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="ifrmae_page">
      <div class="kefu-empty">{{ statusText }}</div>
    </div>
  </div>
</template>

<script>
import { getKefuContact, openKefuUrl } from "@/common/kefu";

export default {
  computed: {
    baseInfo() {
      return this.$store.getters.getBaseInfo || {};
    },
    kefuSrc() {
      const fromQuery = this.$route && this.$route.query && this.$route.query.url;
      if (fromQuery) {
        return String(fromQuery).trim();
      }
      return getKefuContact(this.baseInfo).url || "";
    },
    statusText() {
      if (this.kefuSrc) {
        try {
          const text = this.$t("my.kefu_connecting");
          if (text && text !== "my.kefu_connecting") {
            return text;
          }
        } catch (error) {
          /* ignore */
        }
        return "Connecting to support…";
      }
      try {
        const text = this.$t("my.kefu_unavailable");
        if (text && text !== "my.kefu_unavailable") {
          return text;
        }
      } catch (error) {
        /* ignore */
      }
      return "Support is temporarily unavailable. Please try again later";
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
  },
  mounted() {
    // 与在线客服入口一致：整页跳转，避免 iframe 套回本站首页
    if (this.kefuSrc) {
      openKefuUrl(this, this.kefuSrc);
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";

.kefu-empty {
  padding: 2rem 1rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.9rem;
}
</style>
